<template>
<div>
    <div v-if="(student && student.id)" class="modal-overlay">
        <div class="modal-content">
            <h3>{{ $t('student-details') }}</h3>
            <Avatar :userId="student?.student_id" class="avatar avatar--large mb-2 mx-auto"/>
            <div class="col-12 text-left">
                <p v-if="student">
                    {{ $t("id") }}:    <strong>{{ student.student_id }}</strong>
                    {{ $t("name") }}:    <strong>{{ student.student_displayName }}</strong>
                </p>
                <p v-if="student.examiner_displayName">
                	{{ $t("examiner") }}:    <strong>{{student.examiner_displayName}}</strong>
                </p>
                <p v-if="student">
                    <template v-if="additionaluserinfo.programme">
                    	{{ $t('programme') }}: <strong>{{ this.$config.getProgrammeNameById(additionaluserinfo.programme) }}</strong>
                    </template>
                    <template v-if="additionaluserinfo.year">
                    	{{ $t('year') }}: <strong>{{additionaluserinfo.year}}</strong>
                    </template>
                    <template v-if="additionaluserinfo.year">
                    	{{ $t('group') }}: <strong>{{ this.$config.getGroupNameById(additionaluserinfo.group) }}</strong>
                    </template>
                </p> 
            </div>
            <div class="modal-actions">
                <button type="button" class="btn btn-secondary" @click="close">{{ $t('cancel') }}</button>
                <button type="button" class="btn btn-primary" @click="confirm">{{ buttonLabel }}</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Avatar from '../../../components/Avatar.vue';
import "@/styles/components/studentinfo.scss"; 

export default {
	data() {
		return {
			ready: false,
			checkedin: false,
            token:null,
            urlHasToken: false,
            error: null,
            event: null,
            checkindatetime: null,
            loading: true,
            additionaluserinfo: {
            	programme: null,
                year: null,
                group: null
            }
		};
	},
    props: {
        student: {
            type: Object
        },
        role: {
            type: String
        },
    },
	watch: {
		student: {
			handler() {
				this.getUserInfo()
			}
		}
  	},
    components: {
        Avatar
    },
    methods: {
        close(){
            this.$emit('close');
        },
        confirm(){
            this.$emit('confirm')
        },
        getUserInfo(){
			if(this.student && this.student.id){
				this.$users.getUserById.call(this, this.student.id).then(user => {
					if(user){
						this.additionaluserinfo = user
					}
				});
			} else {
				this.additionaluserinfo = {}
			}
        }
    },
    computed: {
    	buttonLabel(){
    		if(this.role == 'examiner'){
				if(this.student.status == 1){
					return this.$t('start')
				}
				if(this.student.status == 2){
					return this.$t('view')
				}
				if(this.student.status == 3){
					if(this.student.examiner_id == this.$UserSession.getValue('id')){
						return this.$t('resume')
					} else {
						return this.$t('view')
					}
				}
				if(this.student.status == 4){
					return this.$t('restart')
				}
    		}
    		return this.$t('view')
    	}
    }
}
</script>